import { Box, BoxProps, forwardRef, useStyleConfig } from '@chakra-ui/react';

import ReactDatePicker from 'react-datepicker';
import type { ReactDatePickerProps } from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

export interface DatePickerProps extends ReactDatePickerProps {
  boxProps?: BoxProps;
}

const DatePicker = forwardRef<DatePickerProps, 'input'>(
  ({ boxProps, ...props }, ref) => {
    const style = useStyleConfig('DatePicker');

    return (
      <Box __css={style} {...boxProps}>
        <ReactDatePicker
          formatWeekDay={(date) => date.charAt(0)}
          {...props}
          ref={ref}
        />
      </Box>
    );
  }
);

DatePicker.displayName = 'ChakraDatePicker';

export default DatePicker;
